import React from 'react';
import { NavLink, useNavigate } from 'react-router';
import { useAuth } from '../context/AuthContext';
import { useSelector, useDispatch } from 'react-redux';
import { setFilter } from '../redux/filterState';
import { buildFilterQuery } from "../utils/buildFilterQuery"

const Navbar = ({ kategorien }) => {
  const { user, handleLogout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const filters = useSelector(state => state.filters);
  const selectedKategorie = useSelector(state => state.filters.kategorie);

  const handleNavigate = (target) => {
    navigate(target);
  };

  const logoutUser = async () => {
    await handleLogout();
    navigate('/');
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light shadow-sm mb-4">
      <div className="container-fluid">
        <div className="d-flex flex-row align-items-center justify-content-between w-100">

          {/* left side: Brand + Menu */}
          <div className="d-flex align-items-center">
            <button className="navbar-toggler me-1" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>

            {/* MENU (dashboard, objects and others) */}
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                <li className="nav-item dropdown">
                  <button
                    className="nav-link dropdown-toggle btn btn-link"
                    id="objekteDropdown"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    style={{ textDecoration: 'none' }}
                    onClick={() => handleNavigate('/objekte')}
                  >
                    Kolektanto
                  </button>
                  <ul className="dropdown-menu" aria-labelledby="objekteDropdown">
                    <li className="nav-item">
                      <button className="dropdown-item" onClick={() => handleNavigate('/add')}>
                        Objekt erfassen
                      </button>
                    </li>
                  </ul>
                </li>
                <li className="nav-item dropdown">
                  <button
                    className="nav-link dropdown-toggle btn btn-link"
                    id="stammdatenDropdown"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    style={{ textDecoration: 'none' }}
                  >
                    Stammdaten
                  </button>
                  <ul className="dropdown-menu" aria-labelledby="stammdatenDropdown">
                    <li><button className="dropdown-item" onClick={() => handleNavigate('/ablageorte_api')}>Ablageorte</button></li>
                    <li><button className="dropdown-item" onClick={() => handleNavigate('/eigentuemer_api')}>Eigentümer</button></li>
                    <li><button className="dropdown-item" onClick={() => handleNavigate('/kategorien_api')}>Kategorien</button></li>
                    <li><button className="dropdown-item" onClick={() => handleNavigate('/laender_api')}>Länder</button></li>
                    <li><button className="dropdown-item" onClick={() => handleNavigate('/materialien_api')}>Materialien</button></li>
                    <li><button className="dropdown-item" onClick={() => handleNavigate('/typen_api')}>Typen</button></li>
                    <li><button className="dropdown-item" onClick={() => handleNavigate('/waehrungen_api')}>Währungen</button></li>
                    <li><button className="dropdown-item" onClick={() => handleNavigate('/zustaende_api')}>Zustände</button></li>
                  </ul>
                </li>
                <li className="nav-item">
                  <button className="nav-link btn btn-link" onClick={() => handleNavigate("/dashboard")}
                    data-bs-toggle="tooltip"
                    title="Statistik Dashboard">
                    📊
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className="nav-link btn btn-link"
                    onClick={() => handleNavigate("/dashboard/kpi")}
                    data-bs-toggle="tooltip"
                    title="KPI Board"
                  >
                    📈
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className="nav-link btn btn-link"
                    onClick={() => {
                      const query = buildFilterQuery(filters);
                      window.open(`/objekte/print?${query}`, "_blank");
                    }}
                    data-bs-toggle="tooltip"
                    title="Objektliste drucken/exportieren"
                  >
                    🖨️
                  </button>
                </li>
              </ul>
            </div>
          </div>

          {/* right: categories and user */}
          <div className="d-flex align-items-center">
            {Array.isArray(kategorien) && kategorien.length > 0 && (
              <div className="d-flex align-items-center me-3">
                <div className="btn-group" role="group" aria-label="Kategorie Switch">
                  {kategorien.map(k => (
                    <button
                      key={k.id}
                      type="button"
                      className={`btn btn-outline-dark btn-sm ${String(selectedKategorie) === String(k.id) ? 'active' : ''}`}
                      onClick={() => dispatch(setFilter('kategorie', k.id))}
                    >
                      {k.name}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* user dropdowns with profil function and logout */}
            <div className="dropdown">
              <button className="btn btn-outline-primary dropdown-toggle" type="button" id="userMenuButton"
                data-bs-toggle="dropdown" aria-expanded="false">
                {user?.first_name && user?.last_name
                  ? `${user.first_name} ${user.last_name}`
                  : (user?.username || "Benutzer")
                }
              </button>
              <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userMenuButton">
                <li><button className="dropdown-item" onClick={() => handleNavigate('/profil')}>Profil</button></li>


                {isAdmin && (
                  <li><hr className="dropdown-divider" /></li>
                )}

                {isAdmin && (
                  <li><button className="dropdown-item" onClick={() => handleNavigate('/admin')}>Admin-Panel</button></li>
                )}



                <li><hr className="dropdown-divider" /></li>

                <li><button className="dropdown-item" onClick={logoutUser}>Logout</button></li>

              </ul>
            </div>

          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
